import { useMemo } from 'react';

import { SessionProvider, useSession } from 'next-auth/react';

import { AppProvider } from 'context/AppContext';
import { mapAuthSessionUserToAppUser } from 'services/auth/sessionUser';

const getAppDataWithAuthSession = (appData, authUser) => {
  const appDataValue = appData || {};
  const existingUser = appDataValue.header?.user || appDataValue.user;
  const user = existingUser || authUser;

  if (!user) {
    return appDataValue;
  }

  return {
    ...appDataValue,
    user: appDataValue.user || user,
    header: {
      ...(appDataValue.header || {}),
      user: appDataValue.header?.user || user,
    },
  };
};

export const AuthSessionContextProvider = ({ value = {}, children }) => {
  const { data: session } = useSession();
  const authUser = mapAuthSessionUserToAppUser(session?.user);
  const appData = useMemo(
    () => getAppDataWithAuthSession(value, authUser),
    [authUser, value]
  );

  return <AppProvider value={appData}>{children}</AppProvider>;
};

const AuthSessionAppProvider = ({ value = {}, children }) => (
  <SessionProvider refetchOnWindowFocus={false}>
    <AuthSessionContextProvider value={value}>
      {children}
    </AuthSessionContextProvider>
  </SessionProvider>
);

export default AuthSessionAppProvider;
